exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th, td {\n  padding: 0.3rem; }\n\ntable {\n  background-color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/admin-state/costcenter-transaction-item/costcenter-transaction-item.component.scss
// module id = ../../../../../src/app/admin-state/costcenter-transaction-item/costcenter-transaction-item.component.scss
// module chunks = main